var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"timer",class:this.time < 0.2 * _vm.inittime ? 'timeouting' : ''},[_c('b-icon-clock',{attrs:{"font-scale":"1.1"}}),_vm._v(" "+_vm._s(_vm.counter)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }